import React from "react";
import './Home.css'

function Services() {

    return(
        <>


            <div className="items">
        
                <h1 style={{color:"black"}}>Services </h1>
                <h1 style={{color:"black"}}>Why Choosing Us???...</h1>
                <p style={{color:"black"}}>If you're going from one place to another, you're travelling.
                     People love to go travelling to see new places and experience different cultures.</p>
                

                     <h1 style={{color:"black"}}>Our Community </h1>
                     <p style={{color:"black"}}>We believe in giving back and being an active part of our community of Fun-O-Fun</p>
                <button className="btn1">Read More</button>
          
            </div>
        


        
        </>
    )
    
}
export default Services